import { render } from "./GroupForm.vue?vue&type=template&id=cf4e4fb4&scoped=true"
import script from "./GroupForm.vue?vue&type=script&lang=js"
export * from "./GroupForm.vue?vue&type=script&lang=js"

import "./GroupForm.vue?vue&type=style&index=0&id=cf4e4fb4&lang=scss&scoped=true"

import exportComponent from "F:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cf4e4fb4"]])

export default __exports__